<template>

    <div id="wx_login_container">
        <div style="font-size: 25px; margin-top: 5%;  font-weight: 600;">
            扫码登录
        </div>

        <!-- 微信二维码-->
        <div class="wx_login_qr_out">
            <div class="wx_login_qr">
                <!--同意了隐私政策-->
                <div class="loader-container" v-if="agreementCheck && !wxIframe">
                    <div class="loader"></div>
                    <b>加载中...</b>
                </div>

                <div  style="margin-top:53% " v-show="agreementCheck && wxIframe">
                    <div id="wx_login_or_id" ></div>
                </div>

                <!--未同意隐私政策  v-show="!agreementCheck" -->
                <div class="wx_no_img" v-show="!agreementCheck">
                    <div style="text-align: center; font-size: 15px;  color: #3f3f46;">
                        同意协议
                        <br>
                        获取二维码
                    </div>
                </div>
            </div>

        </div>
        <!-- 隐私政策 -->
        <div class="privacy_container">
            <div class="description_wx">
                <div>
                    使用微信扫一扫登录
                </div>
                <div>
                    "慧策登录"
                </div>
            </div>
            <el-form-item style="margin-top: 10px;font-size: 13px;"  label="">
                <el-checkbox size="small" style="color: #999;" v-model="subAgreementCheck" label=" " value="">
                </el-checkbox>
                <div @click="subAgreementCheck = !subAgreementCheck"
                     style="color: #999;font-size: 11px;user-select: none;cursor:pointer"> 我已阅读并同意
                </div>
                <div class="agreement" @click="privacyPolicy">
                    《隐私政策》
                </div>
            </el-form-item>
        </div>
    </div>

</template>
<script lang="ts" setup>
import {defineEmits, ref, watch} from "vue";
import {privacyPolicy} from "@/components/Agreement"
import {useEventListener} from "@vueuse/core";

const props = defineProps<{
    agreementCheck?: boolean
}>()

const emits = defineEmits([
        'updateAgreementCheck',
        'loginOk',
        'smsBind'
    ]
)

useEventListener(window, 'message', (evt) => {
    console.log("收到消息；",evt)
    if(evt.data.action == 'ok') {
        emits('loginOk');
    } else if(evt.data.action == 'sms') {

        emits('smsBind', evt.data.key);
    }
});

const subAgreementCheck = ref(false)

onMounted(() => {
    subAgreementCheck.value = props.agreementCheck
    if (subAgreementCheck.value) {
        getWxIframe()
    }

});

watch(subAgreementCheck, () => {
    //console.log(subAgreementCheck.value)
    emits('updateAgreementCheck', subAgreementCheck.value)
    if (subAgreementCheck.value) {
        //同意隐私政策
        loadingWxRq()
        var intervalId = setInterval(() => {
            getWxIframe()
            if (wxIframe) {
                wxIframe.value = null
                setTimeout(() => {
                    getWxIframe()
                }, 350)
                clearInterval(intervalId);
            }
        }, 100);


    } else {
        //未同意隐私政策
        removeIframe(wxIframe.value)
    }
})
var wxLogin = ref({})

// 加载二维码
const loadingWxRq = () => {
    const isLocal = import.meta.env.VITE_ENV == 'local';
    const host = isLocal ? 'https://login.huice.com/' : document.location.origin;
    wxLogin = new (window as any).WxLogin({
        self_redirect: true,
        // 需要显示内嵌二维码的容器id
        id: 'wx_login_or_id',
        // 应用ID
        appid: import.meta.env.VITE_WX_SIGNATURE,
        // 网页默认即可
        scope: 'snsapi_login',
        // 授权成功后回调的url
        redirect_uri: encodeURIComponent(host + '/open/tm/unified-login/v5/login/wx/callback'),
        // 可设置为简单的随机数加session用来校验
        state: 'WX',
        // 二维码的样式，提供"black"、"white"可选。
        style: 'black',
        // 自定义样式链接
        href:"data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4OyBtYXJnaW4tdG9wOiAyMnB4O2JvcmRlcjogMHB4IHNvbGlkICNlMmUyZTI7fQouaW1wb3dlckJveCAudGl0bGUge2Rpc3BsYXk6IG5vbmU7fQouaW1wb3dlckJveCAuaW5mbyB7ZGlzcGxheTogbm9uZTt9Ci5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0gLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30KLndlYl9xcmNvZGVfc3dpdGNoX3dycCAge2JhY2tncm91bmQtY29sb3I6ICNGRkZGRkY7IHotaW5kZXg6IDEwMDsgZm9udC1zaXplOiAyNXB4O30KLnFsb2dpbl9tb2Qge21hcmdpbi10b3A6IDUwcHg7dGV4dC1hbGlnbjogY2VudGVyO2JhY2tncm91bmQtY29sb3I6IHdoaXRlO2hlaWdodDogMzAwcHg7fQ=="
    });
    /**
     * 二维码自定义样式
     * .impowerBox .qrcode {width: 200px; margin-top: 22px;border: 0px solid #e2e2e2;}
     * .impowerBox .title {display: none;}
     * .impowerBox .info {display: none;}
     * .status_icon {display: none} .status {text-align: center;}
     * .web_qrcode_switch_wrp  {background-color: #FFFFFF; z-index: 100; font-size: 25px;}
     * .qlogin_mod {margin-top: 50px;text-align: center;background-color: white;height: 300px;}
     */
}

const wxIframe = ref<Element|null>(null)
const getWxIframe = () => {
    wxIframe.value = document.querySelector('.wx_login_qr iframe') || null;
}

const removeIframe = (tag) => {
    if (tag) {
        tag.parentNode.removeChild(tag);
        wxIframe.value = null;
    }
}

</script>
<style lang="scss" scoped>

#wx_login_container {
  user-select: none;
  display: flex;
  align-items: center;
  //justify-content: center;
  flex-direction: column;
  height: 450px;
  width: 380px;
  background: white;
  overflow: visible;
  border-radius: 3px;
  top: -65px;
  left: -11px;
}


.wx_login_qr_out {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 300px;
  height: 250px;
}
.loading-qr {
    display: flex;
    width: 300px;
    height: 200px;
}



.wx_no_img {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 175px;
  width: 175px;
  background-image: url("@/assets/or_code.png");
  background-size: cover;

}

.description_wx {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  div {
    font-size: 13px;
  }
}



//隐私协议按钮
.privacy_container {
  display: flex;
  flex-direction: column;
}

.agreement {
  cursor: pointer;
  display: inline;
  font-weight: 400;
  color: #3d8eff;
  font-size: 12px;
}

//
.loader-container {
  background-color: rgba(255, 255, 255, 0.5);
  width: 180px;
  height: 180px;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 100px;
  left: 100px;
  text-align: center;
  z-index: 1000;
  color: #3d8eff;
}

.loader {
  border: 8px solid rgba(0, 0, 0, 0);
  border-top: 2px solid #3d8eff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 50px auto 10px auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


</style>
